
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import ButtonCustom from "../../../../../../Components/ButtonCustom"
import { Card, ContainerCards, ContainerTags } from "../../styled"
import { faEye } from "@fortawesome/free-solid-svg-icons"
import { LineDivider } from "../../../../../../Components/CustomUi/LineDivider"
import { Empty, Tag } from "antd"
import { corDoModulo } from "../meta"

interface CardsDadosProps {
    dados: any[]
    buscar_cliente: string
    abrir: Function
}

export const CardsDados: React.FC<CardsDadosProps> = ({ dados, buscar_cliente, abrir }) => {
    const dadosFiltrados = dados?.filter((item) => item?.nome?.toLowerCase().includes(buscar_cliente?.toLowerCase()));

    return (
        <ContainerCards>
            {dadosFiltrados?.length > 0 ? dadosFiltrados.map((item) => (
                <Card key={item.cod}>
                    <div className="header__card">
                        <div className="icone__perfil">
                            <div className="icone">{(item?.nome || 'US').substring(0, 2).toUpperCase()}</div>
                            <div className="nome__perfil">
                                <h3>{item?.nome}</h3>
                                <span>Proprietário</span>
                            </div>
                        </div>
                        <div className="acoes__card">
                            <ButtonCustom type="secondary" onClick={() => abrir(item?.cod)} icon={<FontAwesomeIcon icon={faEye} />} />
                        </div>
                    </div>

                    <LineDivider marginTop={5} />

                    <ContainerTags>
                        {item?.modulos?.map((modulo: any, idx: number) => (
                            <Tag key={idx} color={corDoModulo(modulo?.modulo_nome)} style={{ padding: '3px 10px', fontWeight: 'bold', width: 'fit-content' }}>
                                {modulo?.modulo_nome}
                            </Tag>
                        ))}
                    </ContainerTags>
                </Card>
            )) : (
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '40px 0', color: '#999' }}>
                    <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description={
                            <>
                                {' '}
                                <b>'{buscar_cliente}'</b> não encontrado!
                            </>
                        }
                    />
                </div>
            )}
        </ContainerCards>
    )
}